import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Replay5Icon(props: IconProps) {
    return <Icon {...props} iconKey={"replay_5"}/>
}
